import { render, staticRenderFns } from "./CSATSettings.vue?vue&type=template&id=a8318fca"
import script from "./CSATSettings.vue?vue&type=script&lang=js"
export * from "./CSATSettings.vue?vue&type=script&lang=js"
import style0 from "./CSATSettings.vue?vue&type=style&index=0&id=a8318fca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports